import React from 'react';
import { API_CONFIG } from './config-env.js';
import pako from "pako";
const axios = require('axios');

// Casaideas tiene DB y catálogo de tiendas propios por ambiente (dev vs
// prod, verificado con AWS CLI: RDS y bucket de tiendas.json distintos), y
// este build de xflow_external apunta a uno u otro según su .env por rama.
// El storeId de una misma tienda difiere entre ambos catálogos, así que la
// URL SÍ debe venir de REACT_APP_STORES_CATALOG_URL (ver .env por rama);
// este hardcode es solo el fallback de prod por si la variable faltara.
const STORES_CATALOG_URL = "https://d3pawg9a8lidc4.cloudfront.net/casaideas/public/files/tiendas.json";

const FALLBACK_CASA_IDEAS_STORES = [
	{ storeName: "La Paz", code: "MD-LP01", tipo: "ciudad" },
	{ storeName: "Santa Cruz", code: "MD-SC04", tipo: "ciudad" },
	{ storeName: "Cochabamba", code: "MD-CB01", tipo: "ciudad" },
	{ storeName: "Sucre", code: "MD-SU01", tipo: "ciudad" },
	{ storeName: "La Paz Multicine", code: "MD-LP02", tipo: "pickup" },
	{ storeName: "La Paz San Miguel", code: "MD-LP03", tipo: "pickup" },
	{ storeName: "Santa Cruz Ventura", code: "MD-SC02", tipo: "pickup" },
	{ storeName: "Cochabamba 2", code: "MD-CB02", tipo: "pickup" },
];

let casaIdeasStoresCache = null;

export function normalizeOfficeCode(code) {
	return String(code || "").replace(/^MD-/i, "").trim().toUpperCase();
}

export function normalizeStoreCode(code) {
	const officeCode = normalizeOfficeCode(code);
	return officeCode ? "MD-" + officeCode : "";
}

export function buildStoreOptions(stores) {
	return (stores || [])
		.filter((store) => store && store.code)
		.map((store) => ({
			store: store.store || (store.storeName ? "Sucursal " + store.storeName : store.STRING_VALUE || store.code),
			code: normalizeOfficeCode(store.code),
			type: store.tipo || store.type || "",
			raw: store,
		}));
}

export async function getCasaIdeasStores() {
	if (casaIdeasStoresCache) {
		return casaIdeasStoresCache;
	}

	try {
		const url = API_CONFIG.storesCatalogUrl || STORES_CATALOG_URL;
		const response = await axios({ url, method: "get" });
		casaIdeasStoresCache = Array.isArray(response.data) ? response.data : FALLBACK_CASA_IDEAS_STORES;
	} catch (error) {
		console.log("No se pudo cargar tiendas.json, usando fallback", error);
		casaIdeasStoresCache = FALLBACK_CASA_IDEAS_STORES;
	}

	return casaIdeasStoresCache;
}

export function getStoreCodeByOfficeCode(officeCode, stores) {
	const normalizedOfficeCode = normalizeOfficeCode(officeCode);
	const store = (stores || []).find((item) => normalizeOfficeCode(item.code) === normalizedOfficeCode);
	return store && store.code ? store.code : normalizeStoreCode(normalizedOfficeCode);
}

export function getParentOfficeCode(officeCode, stores) {
	const normalizedOfficeCode = normalizeOfficeCode(officeCode);
	const currentStore = (stores || []).find((item) => normalizeOfficeCode(item.code) === normalizedOfficeCode);

	if (!currentStore || currentStore.tipo !== "pickup") {
		return normalizedOfficeCode;
	}

	const cityPrefix = normalizedOfficeCode.substring(0, 2);
	const parentStore = (stores || []).find(
		(item) => item.tipo === "ciudad" && normalizeOfficeCode(item.code).substring(0, 2) === cityPrefix
	);

	return parentStore ? normalizeOfficeCode(parentStore.code) : normalizedOfficeCode;
}

export function getStoreNameByOfficeCode(officeCode, stores) {
	const normalizedOfficeCode = normalizeOfficeCode(officeCode);
	const store = (stores || []).find((item) => normalizeOfficeCode(item.code) === normalizedOfficeCode);
	return store ? "Sucursal " + (store.storeName || store.STRING_VALUE || normalizedOfficeCode) : "";
}

export function applyExternalDarkMode(search) {
	const params = new URLSearchParams(search || "");
	const isDarkMode = String(params.get("darkmode") || "").toLowerCase() === "true";

	if (typeof document !== "undefined") {
		document.documentElement.classList.toggle("xflow-external-dark", isDarkMode);
		document.body.classList.toggle("xflow-external-dark", isDarkMode);
	}

	return isDarkMode;
}

export function getUrlSearchParams(search) {
	return new URLSearchParams(search || "");
}

export async function callexternalApiOld(base_url, apiname, apimethod, _data, token) {
	var resp = {}
	console.log("token:", token)
	await axios({
		url: base_url + apiname,
		headers: token ? { 'Authorization': 'Bearer ' + token } : null,
		data: _data,
		method: apimethod
	}).then(response => response.data).then(data => {
		resp = data
	}).catch(function (error) {
		console.log(">>>>>>>>", error)
	})
	return resp
}

async function downloadAndParseJson(presignedUrl) {
	const response = await fetch(presignedUrl);

	if (!response.ok) {
		throw new Error("Error descargando archivo");
	}
	return await response.json();
}

export async function callexternalApi(base_url, apiname, apimethod, _data, token, apikey) {
	let resp = {};
	//console.log("token:", token);
	//console.log("apikey:", apikey);

	// Construimos headers dinámicamente
	let headers = { "Content-Type": "application/json" };
	if (token) {
		headers["Authorization"] = "Bearer " + token;
	}
	if (apikey) {
		headers["x-api-key"] = apikey;
	}


	await axios({
		url: base_url + apiname,
		headers: headers,
		data: _data,
		method: apimethod,
	})
		.then((response) => response.data)
		.then((data) => {
			resp = data;
		})
		.catch(function (error) {
			console.log(">>>>>>>>", error);
		});

	return resp;
}


export async function callApi(apiname, apimethod, _data, token) {
	var resp = {}
	await axios({
		url: API_CONFIG.base_url + apiname,
		headers: token ? { 'Authorization': 'Bearer ' + token } : null,
		data: _data,
		method: apimethod
	}).then(response => response.data).then(data => {
		resp = data
	}).catch(function (error) {
		console.log(">>>>>>>>", error)
	})
	return resp
}


export function findObjName(_event) {

	var continueSerching = true
	var objName = "";

	var event = _event.target

	while (continueSerching) {
		if (event.name || event.attributes.name) {

			//	console.log("encontramos",event.name ,  event.attributes.name )
			continueSerching = false
			objName = event.name ? event.name : event.attributes.name.nodeValue

		} else {
			event = event.parentNode

		}
	}

	return objName
}

export function parseFormData(_formData) {
	var parsedFormData = {}
	try {
		for (var key in Object.keys(_formData)) {
			var field = Object.keys(_formData)[key]

			if (_formData[field].value !== undefined) {
				let fieldValue = _formData[field].value
				parsedFormData[field.toLowerCase()] = fieldValue
			} else {
				parsedFormData[field.toLowerCase()] = _formData[field].values
			}

		}

	} catch (err) {
		console.log(">>>>>>>>>>" + err)
	} finally {
		return parsedFormData
	}

}

export function itemRender(current, type, originalElement) {
	if (type === "prev") {
		return <a href="#0">Previous</a>;
	}
	if (type === "next") {
		return <a href="#0">Next</a>;
	}
	return originalElement;
}

export function onShowSizeChange(obj) {

}
export function find(_json, _value, _key) {
	var pos = -1

	_json.map(function (key, item) {
		if (key[_key] == _value) {
			pos = item
		}
	});
	return pos
}
export async function searchHandler(event, _filterConfig, _showMore, _apiName, _token, _apikey) {
	//console.log("hola")
	//console.log(event.target.name)

	var filterConfig = _filterConfig
	var showMore = _showMore



	var option = findObjName(event)


	if (_filterConfig[option]) {


		var options = event.target.options;

		var value = event.target.value;
		if (options) {
			value = []
			for (var i = 0, l = options.length; i < l; i++) {
				if (options[i].selected) {

					if (isNaN(parseInt(options[i].value))) {
						value.push((options[i].value));
					} else {
						value.push(parseInt(options[i].value));
					}


				}
			}
			if (value.length === 1) {
				value = value[0] + ""
			}

		}
		//console.log(event.target.name, "val", value)


		filterConfig[event.target.name].value = value
		return {
			filterConfig: _filterConfig,
			showMore: _showMore
		}
	} else if (option === "showMore") {
		showMore = _showMore ? false : true
		return {
			filterConfig: _filterConfig,
			showMore: showMore
		}
	} else if (option === "search") {


		var formData = parseFormData(_filterConfig)
		formData["username"] = "admin"
		formData["apikey"] = _apikey
		//formData["includeEvent"] = true

		console.log(new Date(), "Inicia llamada al Back Paso 1")
		let resp = await callexternalApi("", _apiName, "post", formData)

		let reports = {}

		if (_apiName.includes("/api/S3/report/orders")) {
			if (resp.orders) {
				console.log("Directo")
				reports = {
					orders: resp.orders,
					ordersskus: resp.ordersskus
				}
			} else {
				console.log(new Date(), "llamada al Back Paso 2")
				reports = await downloadAndParseJson(resp.url)
				console.log(new Date(), "Finalizado")
				console.log("reports", reports)
			}

		} else {
			Object.keys(resp).map(function (item) {
				//console.log(item)
				if (Array.isArray(resp[item])) {
					//console.log("es reporte", resp[item])
					reports[item] = (resp[item])
				}
			});
		}




		return {
			tableData: reports
		}
	} else if (event.target.name === "refresh") {

		Object.keys(_filterConfig).map(function (key) {
			let item = _filterConfig[key]
			item.value = ""
		});

		return {
			filterConfig: _filterConfig,
			tableData: {},
			showMore: showMore
		}
	}
}

export function parseCurrencyToNumber(currencyString) {
	// Elimina todo excepto los dígitos y el separador decimal
	const numericString = currencyString.replace(/[^0-9,.-]/g, '').replace(',', '.');

	// Convierte el resultado en número flotante
	let number = parseFloat(numericString);

	// Verifica si la conversión fue exitosa y redondea a 1 decimal
	return isNaN(number) ? null : parseFloat(number.toFixed(2));
}
export async function filterHandler(event, _filterConfig, _tableData) {
	//console.log("hola")
	//console.log(event.target.name)

	var filterConfig = _filterConfig

	if (_filterConfig[event.target.name]) {
		//console.log("existe")
		//console.log("val", event.target.value)
		filterConfig[event.target.name].value = event.target.value
		return {
			filterConfig: _filterConfig,
		}
	} else if (event.target.name == "search") {

		//console.log("actu", _tableData.rows.length)
		var tableData = { columns: _tableData.columns, rows: [] }
		var newRows = []

		var fieldsToEval = []
		Object.keys(_filterConfig).map(function (key) {
			let item = _filterConfig[key]
			if (item.value != "") {
				fieldsToEval.push({ field: key, value: item.value, type: item.type })
			}
		});

		if (fieldsToEval.length > 0) {
			_tableData.rows.map(function (item) {
				let isValid = true
				for (var key in fieldsToEval) {
					Object.keys(item).map(function (col) {
						if (isValid) {
							if (fieldsToEval[key].field == col) {

								if ((item[col])) {
									if (fieldsToEval[key].type == "TEXT") {
										if ((item[col]).toUpperCase().indexOf((fieldsToEval[key].value).toUpperCase()) < 0) {
											isValid = false
										}
									} else if (fieldsToEval[key].type == "NUMBER") {
										if (item[col] != fieldsToEval[key].value) {
											isValid = false
										}
									} else if (fieldsToEval[key].type == "SELECT") {
										if (item[col] != fieldsToEval[key].value) {
											isValid = false
										}
									}
								} else {
									isValid = false
								}

							}
						}
					})
				}
				if (isValid) {
					newRows.push(item)
				}
			});
			tableData["rows"] = newRows

		} else {
			tableData = { columns: _tableData.columns, rows: _tableData.rows }
		}
		return {
			tableData: tableData
		}
	} else if (event.target.name == "refresh") {

		Object.keys(_filterConfig).map(function (key) {
			let item = _filterConfig[key]
			item.value = ""
		});

		return {
			filterConfig: _filterConfig,
			tableData: _tableData
		}
	}
}

/**
 * Devuelve un instante con la hora de Bolivia y su offset declarado explicito:
 * "YYYY-MM-DDTHH:mm:ss-04:00".
 *
 * Existe porque la fecha de facturacion atraviesa cuatro procesos con zonas
 * distintas (RDS y Aurora en UTC-4, Lambdas en UTC) y ninguno la declaraba.
 * Mandar un Date crudo deja que cada tramo la reinterprete segun su propia
 * zona; con el offset adentro, el instante es el mismo para todos.
 *
 * Se formatea contra America/La_Paz y no contra la zona del navegador, asi que
 * un cajero con el reloj en otra zona horaria igual manda hora de Bolivia.
 * Bolivia no tiene horario de verano, por eso el -04:00 es constante.
 */
export function instanteBolivia(fecha) {
	const d = fecha instanceof Date ? fecha : fecha ? new Date(fecha) : new Date();
	if (isNaN(d.getTime())) return null;

	const partes = new Intl.DateTimeFormat("en-CA", {
		timeZone: "America/La_Paz",
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hour12: false,
	})
		.formatToParts(d)
		.reduce((acc, p) => {
			acc[p.type] = p.value;
			return acc;
		}, {});

	// algunos motores devuelven "24" para la medianoche
	const hora = partes.hour === "24" ? "00" : partes.hour;

	return `${partes.year}-${partes.month}-${partes.day}T${hora}:${partes.minute}:${partes.second}-04:00`;
}
